import { IonSegment, IonSegmentButton, SegmentCustomEvent } from "@ionic/react";

export type TabItem<T extends string> = Readonly<{
  label: string;
  value: T;
  isDisabled?: boolean;
}>;

export type TabsProps<T extends string> = Readonly<{
  tabs: Array<TabItem<T>>;
  initialTab: T;
  onChange: (newTabValue: T) => void;
}>;

export function Tabs<T extends string>(props: TabsProps<T>) {
  const { tabs, initialTab, onChange } = props;

  function handleTabChange(newTabValue: T) {
    const selectedTabItem = tabs.find((tab) => tab.value === newTabValue);

    if (selectedTabItem && !selectedTabItem.isDisabled) {
      onChange(newTabValue);
    }
  }

  return (
    <div css={{ width: "100%" }}>
      <IonSegment
        value={initialTab}
        onIonChange={(e: SegmentCustomEvent) => handleTabChange(e.detail.value as T)}
        css={{ width: "100%", display: "flex" }}
      >
        {tabs.map(({ label, value, isDisabled }) => (
          <IonSegmentButton
            key={value}
            color="primary"
            value={value}
            disabled={isDisabled}
            css={{ flex: "1 1 auto", minWidth: 0 }}
          >
            <div
              css={{
                display: "block",
                alignSelf: "center",
                maxWidth: "100%",
                lineHeight: "22px",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                boxSizing: "border-box",
                fontSize: "14px",
                fontWeight: 500,
                transition: "color 0.15s linear 0s, opacity 0.15s linear 0s",
                color: "inherit",
                textAlign: "center",
                pointerEvents: "none",
              }}
            >
              {label}
            </div>
          </IonSegmentButton>
        ))}
      </IonSegment>
    </div>
  );
}
